var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"column-one"},[_vm._t("one")],2),_c('div',{staticClass:"column-two",attrs:{"id":"column-two"}},[_vm._t("two")],2),_c('div',{staticClass:"column-three"},[_vm._t("three")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }